import firebase from 'firebase/app'
import 'firebase/auth'
import api from '@/api/config'

let pending
let readyUid
export async function ensureMemberSession () {
  const account = firebase.auth().currentUser
  if (!account) { readyUid = null; return }
  if (readyUid === account.uid) return
  if (pending) return pending
  pending = (async () => {
    const user = JSON.parse(localStorage.getItem('userData') || '{}')
    if (!user.key) throw new Error('MEMBER_PROFILE_REQUIRED')
    const result = await api.post(`/qpartner/session/${encodeURIComponent(user.key)}`)
    await account.getIdToken(!!result.data.refreshToken)
    readyUid = account.uid
  })()
  try { await pending } finally { pending = null }
}
